<template>
    <div>
        <v-dialog
            v-if="currentItem !== undefined"
            v-model="popup"
            width="500px"
            scrollable
            style="max-width: 340px"
        >
            <v-card style="margin-top: 0px; border-radius: 5px">
                <div
                    class="pt-2 grey darken-4"
                    style="
                        border-radius-left: 5px;
                        border-radius-right: 5px;
                        height: 50px;
                    "
                >
                    <v-icon
                        @click="closePopup"
                        white
                        style="float: right; margin-right: 15px; color: white"
                        >clear</v-icon
                    >
                    <span style="color: white; margin-top: 10px" class="ma-3"
                        ><strong>PRENOTAZIONE SLOT SEGRETERIA</strong></span
                    >
                </div>
                <v-card-text class="pt-1" style="height: 350px">
                    <div>
                        <v-layout align-middle row justify-center>
                            <table style="width: 100%">
                                <tr>
                                    <td
                                        class="text-xs-center pa-1"
                                        style="
                                            border: 3px solid white;
                                            border-radius: 10px 0px 0px 10px;
                                            vertical-align: middle;
                                            margin: 2px;
                                            min-width: 20px;
                                            background-color: black;
                                            color: orange;
                                        "
                                    >
                                        <span class="white--text"
                                            ><small
                                                >Data prenotazione</small
                                            ></span
                                        ><br />
                                    </td>
                                    <td
                                        class="cardUp pa-1 no-wrap"
                                        style="width: 70%"
                                    >
                                        {{ dataP }}
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        class="text-xs-center pa-1"
                                        style="
                                            border: 3px solid white;
                                            border-radius: 10px 0px 0px 10px;
                                            vertical-align: middle;
                                            margin: 2px;
                                            min-width: 20px;
                                            background-color: orange;
                                        "
                                    >
                                        <span class="black--text"
                                            ><small
                                                >Orario prenotazione</small
                                            ></span
                                        ><br />
                                    </td>
                                    <td
                                        class="cardUp pa-1 no-wrap"
                                        style="width: 70%"
                                    >
                                        {{ currentItem.valore }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2"><br /></td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <v-text-field
                                            v-model="searchText"
                                            label="Note"
                                            outline
                                            clearable
                                        ></v-text-field>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" align="center">
                                        <v-btn
                                            round
                                            class="success white--text"
                                            @click="openPopup(props.item)"
                                            ><v-icon
                                                small
                                                class="white--text mr-3"
                                                >book_online</v-icon
                                            >
                                            CONFERMA
                                        </v-btn>
                                    </td>
                                </tr>
                            </table>
                        </v-layout>
                    </div>
                </v-card-text>
                <!--v-card-actions>
                    <v-layout align-center row justify-center>
                        <v-btn
                            round
                            primary
                            @click="closePopup"
                            style="margin-top: 30px; align: center"
                            class="blue darken-4 white--text"
                            >Chiudi</v-btn
                        >
                    </v-layout>
                </v-card-actions-->
            </v-card>
        </v-dialog>
        <v-toolbar app color="black" dark>
            <v-toolbar-title data-cy="titleBtn">
                <img
                    class="menuLogo ml-0"
                    src="../assets/images/Logo.png"
                    style="height: 45px"
                    @click="gotoHome()"
                />
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-layout
                v-if="isDesktopMode()"
                align-start
                row
                justify-center
                class="red darken-2 p-0 m-0"
                style="border-radius: 10px 10px 10px 10px"
                ><span class="white--text"
                    ><strong>{{ nomeGara }}</strong> | Booking |
                </span>
            </v-layout>
            <v-spacer></v-spacer>
            <v-icon class="mr-2" @click="filterToggle = !filterToggle"
                >search</v-icon
            >
            <v-icon class="mr-2" @click="reloadPren()">refresh</v-icon>
        </v-toolbar>

        <v-layout align-start row wrap justify-center class="mt-1">
            <v-flex v-if="filterToggle" flex offset-4 xs12 sm4 md4 lg4>
                <v-text-field
                    style="padding: 3px; color: white; background-color: white"
                    v-model="searchText"
                    label="Cerca cognome o team"
                    outline
                    clearable
                    append-icon="search"
                    @input="changedSearch"
                ></v-text-field>
            </v-flex>
            <v-flex
                flex
                xs12
                sm6
                md6
                lg6
                v-if="message !== undefined"
                class="mt-3 p-3 red darken-4 white--text text-xs-center"
            >
                <h3>{{ message }}</h3>
            </v-flex>
            <v-flex
                flex
                xs12
                sm12
                md12
                lg12
                v-if="message == undefined && isDesktopMode()"
            >
                <v-data-table
                    :items="itemsF"
                    hide-actions
                    hide-headers
                    class="elevation-1 mb-5"
                    style="width: 100%"
                >
                    <template slot="items" slot-scope="props">
                        <td
                            class="text-xs-center"
                            style="
                                border-radius: 10px 0px 0px 10px;
                                vertical-align: middle;
                                margin: 2px;
                                min-width: 20px;
                                background-color: black;
                                color: orange;
                                border: 2px solid white
                                width: 10px;
                            "
                        >
                            <span class="white--text"
                                ><small
                                    >Slot di prenotazione ritiro</small
                                ></span
                            ><br />
                            <strong
                                ><v-icon small class="white--text mr-1"
                                    >timer</v-icon
                                >
                                {{ props.item.descrizione }}</strong
                            >
                        </td>
                        <td width="30%">
                            <span>
                                <v-progress-linear
                                    v-model="props.item.DISP"
                                    :color="
                                        props.item.DISP <= 11
                                            ? 'red'
                                            : props.item.DISP > 40
                                            ? 'green'
                                            : 'orange'
                                    "
                                    height="30"
                                    style="
                                        float: right;
                                        padding: 0px;
                                        margin: 0px;
                                        border-radius: 10px 10px 10px 10px;
                                        width: 100%;
                                    "
                                    ><strong
                                        class="black--text ml-2 black--text mt-4"
                                    >
                                        {{ props.item.max - props.item.numP }}
                                        posti disponibili
                                    </strong>
                                </v-progress-linear></span
                            >
                        </td>

                        <td>
                            <v-btn
                                v-if="props.item.DISP > 0"
                                round
                                small
                                class="default black--text"
                                @click="openPopup(props.item)"
                                ><v-icon small class="black--text mr-3"
                                    >book_online</v-icon
                                >
                                PRENOTA RITIRO
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
            <v-flex
                flex
                xs12
                sm12
                md12
                lg12
                v-if="message == undefined && isMobileMode()"
            >
                <v-data-table
                    :items="itemsF"
                    hide-actions
                    hide-headers
                    class="elevation-1 mb-5"
                    style="width: 100%"
                >
                    <template slot="items" slot-scope="props">
                        <td class="cardUp2 pa-1 no-wrap">
                            <span class="ml-2">
                                <strong
                                    ><v-icon small class="black--text mr-1"
                                        >timer</v-icon
                                    >
                                    {{ props.item.descrizione }}</strong
                                >
                            </span>
                            <span>
                                <v-progress-linear
                                    v-model="props.item.DISP"
                                    :color="
                                        props.item.DISP <= 11
                                            ? 'red'
                                            : props.item.DISP > 40
                                            ? 'green'
                                            : 'orange'
                                    "
                                    height="20"
                                    style="
                                        float: right;
                                        padding: 0px;
                                        margin: 0px;
                                        border-radius: 10px 10px 10px 10px;
                                        width: 50%;
                                    "
                                    ><strong
                                        class="black--text ml-2 black--text"
                                    >
                                        {{ props.item.max - props.item.numP }}
                                        posti disponibili
                                    </strong>
                                </v-progress-linear></span
                            >
                            <br />
                            <v-btn
                                v-if="props.item.DISP > 0"
                                round
                                small
                                class="default black--text"
                                @click="openPopup(props.item)"
                                >PRENOTA RITIRO
                                <v-icon small class="black--text ml-3"
                                    >book_online</v-icon
                                >
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
        <v-footer
            v-if="isMobileMode()"
            fixed
            class="grey darken-2"
            style="height: 30px; padding: 10px"
        >
            <v-layout
                align-start
                row
                wrap
                justify-center
                class="red darken-2 p-0 m-0"
                style="border-radius: 10px 10px 10px 10px"
                ><span class="white--text"
                    ><strong>{{ nomeGara }}</strong>
                </span>
            </v-layout>
        </v-footer>
    </div>
</template>

<script>
import helper from '../helper';
const moment = require('moment');

export default {
    components: {
        //      live: LiveRanking,
    },
    name: 'Live',

    data() {
        return {
            items: [],
            itemsF: [],

            compatta: false,
            checkpointSelected: 'TUTTI',
            listaCheckpoints: ['TUTTI'],
            filterToggle: false,
            filterPreferiti: false,
            listaPreferiti: {},

            searchText: '',

            raceID: null,
            nomeGara: '',

            connection: null,

            snackbar: 'AAA',

            myInterval: null,
            sport: '',

            popup: false,
            currentItem: undefined,

            evento: {},
            message: undefined,

            dataPrenotazione: '',

            listaOrari: [],

            mappaConfigurazioni: [],
        };
    },

    beforeCreate() {},

    created() {},

    beforeDestroy() {
        console.log('beforeDestroy:');
        clearInterval(this.myInterval);
    },

    mounted() {
        console.log(this.$route.params.raceID);
        this.raceID = this.$route.params.raceID;
        this.token = this.$route.params.token;
        this.dataPrenotazione = this.$route.params.dataPrenotazione;

        this.dataP = moment(this.$route.params.dataPrenotazione).format(
            'DD/MM/YYYY'
        );

        this.setupOrari();

        this.loadEvento();

        //this.myInterval = setInterval(this.loadEvento, 20000, this);
    },

    methods: {
        reloadPren() {
            this.itemsF = [];
            this.loadEvento();
        },
        setupOrari() {
            this.listaOrari.push({
                descrizione: '00:00-06:15',
                valore: '00:00-06:15',
            });
            this.listaOrari.push({
                descrizione: '06:15-06:30',
                valore: '06:15-06:30',
            });
            this.listaOrari.push({
                descrizione: '06:30-06:45',
                valore: '06:30-06:45',
            });
            this.listaOrari.push({
                descrizione: '06:45-07:00',
                valore: '06:45-07:00',
            });
            this.listaOrari.push({
                descrizione: '07:00-07:15',
                valore: '07:00-07:15',
            });
            this.listaOrari.push({
                descrizione: '07:15-07:30',
                valore: '07:15-07:30',
            });
            this.listaOrari.push({
                descrizione: '07:30-07:45',
                valore: '07:30-07:45',
            });
            this.listaOrari.push({
                descrizione: '07:45-08:00',
                valore: '07:45-08:00',
            });
            this.listaOrari.push({
                descrizione: '08:00-08:15',
                valore: '08:00-08:15',
            });
            this.listaOrari.push({
                descrizione: '08:15-08:30',
                valore: '08:15-08:30',
            });
            this.listaOrari.push({
                descrizione: '08:30-08:45',
                valore: '08:30-08:45',
            });
            this.listaOrari.push({
                descrizione: '08:45-09:00',
                valore: '08:45-09:00',
            });
            this.listaOrari.push({
                descrizione: '09:00-09:15',
                valore: '09:00-09:15',
            });
            this.listaOrari.push({
                descrizione: '09:15-09:30',
                valore: '09:15-09:30',
            });
            this.listaOrari.push({
                descrizione: '09:30-09:45',
                valore: '09:30-09:45',
            });
            this.listaOrari.push({
                descrizione: '09:45-10:00',
                valore: '09:45-10:00',
            });
            this.listaOrari.push({
                descrizione: '10:00-10:15',
                valore: '10:00-10:15',
            });
            this.listaOrari.push({
                descrizione: '10:15-10:30',
                valore: '10:15-10:30',
            });
            this.listaOrari.push({
                descrizione: '10:30-10:45',
                valore: '10:30-10:45',
            });
            this.listaOrari.push({
                descrizione: '10:45-11:00',
                valore: '10:45-11:00',
            });
            this.listaOrari.push({
                descrizione: '11:00-11:15',
                valore: '11:00-11:15',
            });
            this.listaOrari.push({
                descrizione: '11:15-11:30',
                valore: '11:15-11:30',
            });
            this.listaOrari.push({
                descrizione: '11:30-11:45',
                valore: '11:30-11:45',
            });
            this.listaOrari.push({
                descrizione: '11:45-12:00',
                valore: '11:45-12:00',
            });
            this.listaOrari.push({
                descrizione: '12:00-12:15',
                valore: '12:00-12:15',
            });
            this.listaOrari.push({
                descrizione: '12:15-12:30',
                valore: '12:15-12:30',
            });
            this.listaOrari.push({
                descrizione: '12:30-12:45',
                valore: '12:30-12:45',
            });
            this.listaOrari.push({
                descrizione: '12:45-13:00',
                valore: '12:45-13:00',
            });
            this.listaOrari.push({
                descrizione: '13:00-13:15',
                valore: '13:00-13:15',
            });
            this.listaOrari.push({
                descrizione: '13:15-13:30',
                valore: '13:15-13:30',
            });
            this.listaOrari.push({
                descrizione: '13:30-13:45',
                valore: '13:30-13:45',
            });
            this.listaOrari.push({
                descrizione: '13:45-14:00',
                valore: '13:45-14:00',
            });
            this.listaOrari.push({
                descrizione: '14:00-14:15',
                valore: '14:00-14:15',
            });
            this.listaOrari.push({
                descrizione: '14:15-14:30',
                valore: '14:15-14:30',
            });
            this.listaOrari.push({
                descrizione: '14:30-14:45',
                valore: '14:30-14:45',
            });
            this.listaOrari.push({
                descrizione: '14:45-15:00',
                valore: '14:45-15:00',
            });
            this.listaOrari.push({
                descrizione: '15:00-15:15',
                valore: '15:00-15:15',
            });
            this.listaOrari.push({
                descrizione: '15:15-15:30',
                valore: '15:15-15:30',
            });
            this.listaOrari.push({
                descrizione: '15:30-15:45',
                valore: '15:30-15:45',
            });
            this.listaOrari.push({
                descrizione: '15:45-16:00',
                valore: '15:45-16:00',
            });
            this.listaOrari.push({
                descrizione: '16:00-16:15',
                valore: '16:00-16:15',
            });
            this.listaOrari.push({
                descrizione: '16:15-16:30',
                valore: '16:15-16:30',
            });
            this.listaOrari.push({
                descrizione: '16:30-16:45',
                valore: '16:30-16:45',
            });
            this.listaOrari.push({
                descrizione: '16:45-17:00',
                valore: '16:45-17:00',
            });
            this.listaOrari.push({
                descrizione: '17:00-17:15',
                valore: '17:00-17:15',
            });
            this.listaOrari.push({
                descrizione: '17:15-17:30',
                valore: '17:15-17:30',
            });
            this.listaOrari.push({
                descrizione: '17:30-17:45',
                valore: '17:30-17:45',
            });
            this.listaOrari.push({
                descrizione: '17:45-18:00',
                valore: '17:45-18:00',
            });
            this.listaOrari.push({
                descrizione: '18:00-18:15',
                valore: '18:00-18:15',
            });
            this.listaOrari.push({
                descrizione: '18:15-18:30',
                valore: '18:15-18:30',
            });
            this.listaOrari.push({
                descrizione: '18:30-18:45',
                valore: '18:30-18:45',
            });
            this.listaOrari.push({
                descrizione: '18:45-19:00',
                valore: '18:45-19:00',
            });
            this.listaOrari.push({
                descrizione: '19:00-19:15',
                valore: '19:00-19:15',
            });
            this.listaOrari.push({
                descrizione: '19:15-19:30',
                valore: '19:15-19:30',
            });
            this.listaOrari.push({
                descrizione: '19:30-19:45',
                valore: '19:30-19:45',
            });
            this.listaOrari.push({
                descrizione: '19:45-20:00',
                valore: '19:45-20:00',
            });
            this.listaOrari.push({
                descrizione: '20:00-20:15',
                valore: '20:00-20:15',
            });
            this.listaOrari.push({
                descrizione: '20:15-20:30',
                valore: '20:15-20:30',
            });
            this.listaOrari.push({
                descrizione: '20:30-20:45',
                valore: '20:30-20:45',
            });
            this.listaOrari.push({
                descrizione: '20:45-21:00',
                valore: '20:45-21:00',
            });
            this.listaOrari.push({
                descrizione: '21:00-21:15',
                valore: '21:00-21:15',
            });
            this.listaOrari.push({
                descrizione: '21:15-21:30',
                valore: '21:15-21:30',
            });
            this.listaOrari.push({
                descrizione: '21:30-21:45',
                valore: '21:30-21:45',
            });
            this.listaOrari.push({
                descrizione: '21:45-22:00',
                valore: '21:45-22:00',
            });
            this.listaOrari.push({
                descrizione: '22:00-22:15',
                valore: '22:00-22:15',
            });
            this.listaOrari.push({
                descrizione: '22:15-22:30',
                valore: '22:15-22:30',
            });
            this.listaOrari.push({
                descrizione: '22:30-22:45',
                valore: '22:30-22:45',
            });
            this.listaOrari.push({
                descrizione: '22:45-23:00',
                valore: '22:45-23:00',
            });
            this.listaOrari.push({
                descrizione: '23:00-23:15',
                valore: '23:00-23:15',
            });
            this.listaOrari.push({
                descrizione: '23:15-23:30',
                valore: '23:15-23:30',
            });
            this.listaOrari.push({
                descrizione: '23:30-23:45',
                valore: '23:30-23:45',
            });
            this.listaOrari.push({
                descrizione: '23:45-23:59',
                valore: '23:45-23:59',
            });

            this.listaOrari.forEach((elem) => {
                elem.max = 10;
                elem.PERC = 0;
                elem.DISP = 100;
            });
        },

        loadEvento() {
            this.getEventoIcron(this.raceID).then((response) => {
                console.log('getEventoIcron:');
                if (response.evento) {
                    this.evento = response.evento;
                    this.nomeGara = response.evento.descrizione;
                    this.mappaConfigurazioni =
                        response.evento.mappaConfigurazioni;
                }
                this.loadPrenotazioni(this);

                this.myInterval = setInterval(
                    this.loadPrenotazioni,
                    30000,
                    this
                );
            });
        },

        loadPrenotazioni() {
            this.getSlotPrenotazioneEvento(
                this.raceID,
                this.dataPrenotazione
            ).then((response) => {
                let mappa = response.evento.mappaAttributi;
                console.log(JSON.stringify(response.evento.mappaAttributi));

                var _lista = this.listaOrari;
                var listaUpdated = [];

                _lista.forEach((elem) => {
                    let v1 = 'SLOT_' + elem.valore;
                    elem.numP = 0;
                    // console.log(JSON.stringify(v1));
                    if (mappa[v1] !== undefined) {
                        console.log('Eccomi');

                        elem.PERC = Math.ceil(
                            (parseInt(mappa[v1]) / elem.max) * 100
                        );
                        elem.DISP = 100 - elem.PERC;
                        elem.numP = parseInt(mappa[v1]);
                        console.log(
                            elem.DISP + '-->' + elem.numP + '-->' + elem.PERC
                        );
                    } else {
                        elem.PERC = 0;
                        elem.DISP = 100 - elem.PERC;
                    }
                    elem.DISP = 100 - elem.PERC;

                    listaUpdated.push(elem);
                });
                this.itemsF = listaUpdated;
            });
        },

        closePopup() {
            this.popup = false;
            this.currentItem = undefined;
        },
        openPopup(item) {
            this.currentItem = item;
            this.popup = true;
        },

        gotoHome() {
            this.$router.push('/');
        },

        isMobileMode: function () {
            let res = this.$vuetify.breakpoint.name === 'xs';
            return res;
        },
        isDesktopMode: function () {
            return !this.isMobileMode();
        },
    },
};
</script>
<style scoped>
td {
    height: 10px !important;
    _background-image: linear-gradient(60deg, grey, lightgray);
}

.frazioniTitle {
    text-align: left;
    _background-color: lightgrey;
    border-radius: 0px 0px 3px 3px;
}
.orario {
    text-align: left;
    _background-color: #424242;
    _color: orange;
    _border-radius: 5px 5px 5px 5px;
    padding: 2px;
    min-width: 30px;
}
.orario2 {
    text-align: left;
    _background-color: #424242;
    _color: white;
    border-radius: 5px 5px 5px 5px;
    _padding: 5px;
    font-weight: bold;
}
.frazioniValue {
    text-align: center;
    background-color: white;
    border-radius: 0px 0px 3px 3px;
    border-bottom: 1px solid lightgray;
}
.frazioniTitleFinale {
    text-align: center;
    background-color: orange;
    color: black;
    font-style: italic;
    _border: 1px solid lightgray;
    border-radius: 0px 0px 5px 5px;
    font-weight: bold;
}
.cardUp {
    background-color: lightgray;
    color: black;
    border: 3px solid white;
    border-radius: 0px 10px 10px 0px;
}
.cardUp2 {
    background-color: #e0e0e0;
    color: black;
    border: 5px solid white;
    border-radius: 15px 15px 15px 15px;
}
</style>